export default "__VITE_ASSET__BQZnaj4B__"